import React, { useCallback, useEffect, useState } from 'react';
import Webcam from 'react-webcam';
import '../css/mudra.css';

function Camera({ isCameraOn, webcamRef }) {
  const [devices, setDevices] = useState([]);
  const [videoWidth, setVideoWidth] = useState(800);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = Math.min(800, window.innerWidth - 16); 
      setVideoWidth(newWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 

  const handleDevices = useCallback((mediaDevices) => {
    setDevices(mediaDevices.filter(({ kind }) => kind === 'videoinput'));
  }, [setDevices]);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  const whiteBlurStyle = {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    filter: "none",//"blur(8px)", // Adjust the blur intensity as needed
    backgroundColor: "white",
    width: videoWidth,
    height: 500,
  };

  return (
    <div style={{ position: 'relative' }}>
      {devices.map((device, key) => (
        <div key={key} style={whiteBlurStyle} id="mainCam">
          
          <Webcam
            audio={false}
            videoConstraints={{
              height: 500,
              width: videoWidth,
              deviceId: device.deviceId,
            }}
            mirrored={true}
            ref={webcamRef}
            className='rounded'
          />
          
        </div>
        
      ))}
      <span style={{ position: 'absolute', top: 20, right: 20, fontSize: 128 , color:"white"}} id="timer"></span>
    </div>
  );
}

export default Camera;
